// extracted by mini-css-extract-plugin
var _1 = "txBcn95De6jMnl7wGsRQ";
var _2 = "F693jZwVNpnRVgIRTZP7";
var _3 = "kQYSiKLCNzvN8Govrjdd";
var _4 = "muh1FRemt5Smij0KDdC7";
var _5 = "iltJNgSaiPHez_cqSyrn";
var _6 = "XYbMFZbjywrc4pbaFQuR";
var _7 = "zmsueDEd6WGdDIi6T_xD";
var _8 = "UTv4Ut0X3Aw4CH0kL4W6";
var _9 = "YFr64h6Xx6CEp4uRHUD8";
var _a = "CawT0akjb3o6ilsxu7Hm";
var _b = "Nb5mdLrp8i5kDsSiOUmj";
var _c = "GI6TirVD9m4cxbvu0aPQ";
var _d = "b2CVcd0meEeTj2aK_5UB";
var _e = "SrMbNraF04ImBzC5I_dC";
var _f = "bXz2HPoRE0cFyTCiWRPW";
var _10 = "Q2U5et7EEhMN_1VecPsU";
var _11 = "goLgrMb1EOHHx7Jbs8FM";
var _12 = "HKh3PCYOSdmZzM6g00Jd";
var _13 = "YBeKYjOgKn3H3qSPyG36";
var _14 = "gu_dBxcS8caXUDUoKbZL";
var _15 = "R_eoe98iorW5YKnGPeSx";
var _16 = "HK2UlZnkF7h_89rjjsEN";
var _17 = "SZKJFvIVfZihzIexJxGk";
var _18 = "yJ6tVmHH6FZX6geJcNtt";
var _19 = "spOGIGt4ry2xloDy64Pg";
var _1a = "XsywQLxb0cTZ__oELFzg";
var _1b = "xqpjF0RwnGRqpWRYRUGK";
var _1c = "jzIQdw67Bwg1TMkWkRxW";
var _1d = "TZO4nedv_b_Qb4pbMoiW";
export { _1 as "black", _2 as "danger", _3 as "dropdownLink", _4 as "info", _5 as "is-128x128", _6 as "is-16x16", _7 as "is-24x24", _8 as "is-32x32", _9 as "is-48x48", _a as "is-64x64", _b as "is-96x96", _c as "link", _d as "muted", _e as "primary", _f as "secondary", _10 as "success", _11 as "theme-cardiology", _12 as "theme-dermatology", _13 as "theme-empty", _14 as "theme-lab", _15 as "theme-mentalHealth", _16 as "theme-ophthalmology", _17 as "theme-pulmonology", _18 as "theme-referall", _19 as "theme-sleep", _1a as "theme-white-theme", _1b as "theme-xyz", _1c as "warning", _1d as "white" }
